import { NgModule } from '@angular/core';
import { StateSlice } from '../state-slice';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { reducer } from './toast-reducer';
import { initialToastState } from './toast.state';
import { combineReducers } from '@core/utils/state';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.TOAST, (reducer as ActionReducer<any, any>), {
            initialState: initialToastState,
            reducerFactory: combineReducers
        })
    ],
    declarations: []
})
export class ToastStateModule {}
